// extracted by mini-css-extract-plugin
module.exports = {"container":"BusinessInfoForm_container__28-Ji","title":"BusinessInfoForm_title__10JQ8"};